/**
 * Super-admin v2 design tokens (from mock super-admin-v2.jsx).
 */
export const C = {
  bg: "#0F1419",
  bgCard: "#1A1F2A",
  bgSoft: "#252B38",
  bgInput: "#1F252F",
  text: "#F5F1E8",
  textSoft: "#A0A8B5",
  muted: "#6B7280",
  brand: "#D4A574",
  brandDark: "#B8895A",
  brandSoft: "rgba(212,165,116,0.15)",
  /** Тёмный текст поверх бренд-акцента (кнопки/аватары). */
  onBrand: "#0A0E14",
  green: "#10B981",
  greenSoft: "rgba(16,185,129,0.15)",
  orange: "#F59E0B",
  orangeSoft: "rgba(245,158,11,0.15)",
  red: "#EF4444",
  redSoft: "rgba(239,68,68,0.15)",
  blue: "#3B82F6",
  blueSoft: "rgba(59,130,246,0.15)",
  purple: "#8B5CF6",
  purpleSoft: "rgba(139,92,246,0.15)",
  pink: "#EC4899",
  pinkSoft: "rgba(236,72,153,0.15)",
  border: "#2D3441",
  borderSoft: "#252B38",
} as const;

export const FONT = {
  display: "'Fraunces', Georgia, serif",
  body: "'Inter', sans-serif",
  mono: "'JetBrains Mono', monospace",
} as const;

import type { CSSProperties } from "react";

export function inputStyle(): CSSProperties {
  return {
    width: "100%",
    padding: "10px 14px",
    background: C.bgInput,
    border: `1px solid ${C.border}`,
    borderRadius: 10,
    outline: "none",
    fontSize: 13,
    color: C.text,
    fontFamily: FONT.body,
    boxSizing: "border-box",
  };
}

export function btnPrimary(disabled?: boolean): CSSProperties {
  return {
    background: disabled ? C.bgSoft : C.brand,
    color: disabled ? C.muted : "#0A0E14",
    border: "none",
    padding: "10px 20px",
    borderRadius: 10,
    fontSize: 13,
    fontWeight: 700,
    cursor: disabled ? "not-allowed" : "pointer",
  };
}

export function btnSecondary(): CSSProperties {
  return {
    background: "transparent",
    color: C.text,
    border: `1px solid ${C.border}`,
    padding: "10px 20px",
    borderRadius: 10,
    fontSize: 13,
    fontWeight: 700,
    cursor: "pointer",
  };
}
